import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
} from "@mui/material";
import { Home as HomeIcon, ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import MKBox from "../components/MKBox";
import MKButton from "../components/MKButton";
import MKTypography from "../components/MKTypography";
import { PRIMARY_PINK } from "../constants";

function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 8, mb: 8 }}>
      <Paper
        elevation={3}
        sx={{
          p: { xs: 4, md: 8 },
          textAlign: "center",
          borderRadius: 3,
        }}
      >
        <MKBox sx={{ mb: 4 }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "6rem", md: "8rem" },
              fontWeight: "bold",
              color: PRIMARY_PINK,
              mb: 2,
            }}
          >
            404
          </Typography>
          
          <MKTypography variant="h3" fontWeight="bold" mb={2}>
            Page Not Found
          </MKTypography>
          
          <MKTypography variant="body1" color="text.secondary" mb={4}>
            The page you're looking for doesn't exist or has been moved.
          </MKTypography>
        </MKBox>

        <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
          <MKButton
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={() => navigate("/")}
            sx={{
              bgcolor: PRIMARY_PINK,
              color: '#ffffff',
              "&:hover": {
                bgcolor: PRIMARY_PINK,
                opacity: 0.9,
              },
            }}
          >
            Go Home
          </MKButton>
          
          <MKButton
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={{
              borderColor: PRIMARY_PINK,
              color: PRIMARY_PINK,
              "&:hover": {
                borderColor: PRIMARY_PINK,
                bgcolor: "rgba(233, 30, 99, 0.05)",
              },
            }}
          >
            Go Back
          </MKButton>
        </Box>
      </Paper>
    </Container>
  );
}

export default NotFoundPage; 